import { makeAutoObservable } from 'mobx'
import { openApi } from '../../../../helpers/request'
import { message } from 'antd'
import { FormEvent } from 'react'
import i from '../../../../translations/i'

export interface PriceLevel {
    max_cart: number | null
    price: number | null
}

export const DEFAULT_ZONE_COLOR = '#0000FF'

// [[юг, запад], [север, восток]]
export type MapBounds = number[][]

// Что сейчас реально видно на карте — карта сама сообщает об этом после каждого сдвига/зума.
export interface MapView {
    center: number[]
    zoom: number
    bounds: MapBounds | null
}

// Запрос на перемещение карты. Каждый запрос — новый объект, карта применяет его один раз.
export interface MapViewport {
    center?: number[]
    zoom?: number
    bounds?: MapBounds
}

const USER_LOCATION_ZOOM = 12

interface ActiveInterface {
    id: number
    enabled: boolean
    id_crm: string | null
    name: string
    price: any
    minprice: any
    maxprice: any
    coordinates: any[]
    coordinatesGoogle: any[]
    waiting_time: string | null
    delivery_time: number | null
    color: string | null
    price_levels: PriceLevel[]
}

export class zonesController {

    list: any[] = [];

    mapView: MapView = { center: [0, 0], zoom: 2, bounds: null }
    viewport: MapViewport | null = null
    active: ActiveInterface = zonesController.defaultActive()

    modal = false;

    static defaultActive(): ActiveInterface {
        return {
            id: -1,
            enabled: true,
            id_crm: null,
            name: "",
            price: null,
            minprice: null,
            maxprice: null,
            coordinates: [],
            coordinatesGoogle: [],
            waiting_time: null,
            delivery_time: null,
            color: null,
            price_levels: []
        }
    }

    constructor() {
        // mapView обновляется на каждое движение карты, но нужен только в момент создания зоны —
        // не делаем его наблюдаемым, чтобы не перерисовывать страницу при каждом сдвиге.
        makeAutoObservable(this, { mapView: false })
    }

    setMapView(center: number[], zoom: number, bounds: MapBounds | null) {
        this.mapView = { center, zoom, bounds }
    }

    openModal() {
        this.modal = true;
    }

    closeModal() {
        this.modal = false;
    }

    // Геолокация через браузер — одинаково работает и для Яндекс, и для Google карты.
    locateUser() {
        if (typeof navigator === 'undefined' || !navigator.geolocation) {
            return
        }

        navigator.geolocation.getCurrentPosition(
            position => this.setViewport({
                center: [position.coords.latitude, position.coords.longitude],
                zoom: USER_LOCATION_ZOOM
            }),
            error => console.log(error),
            { timeout: 10000 }
        )
    }

    setViewport(viewport: MapViewport) {
        this.viewport = viewport
    }

    // fitView — показать на карте все зоны, а если их нет — место, где находится пользователь.
    getAllZone(fitView: boolean = false) {
        openApi('get', "/setting/delivery_zone")
            .then(success => {
                this.list = success.data

                let coordinatesList: any [] = []

                this.list.map((el: any, index: number) => {
                    // @ts-ignore
                    let coordinatesGoogle = []
                    el.coordinates.map((item: any) => {
                        coordinatesGoogle.push({
                            lat: item[0],
                            lng: item[1]
                        })

                        coordinatesList.push(item)
                    })

                    // @ts-ignore
                    this.list[index].coordinatesGoogle = coordinatesGoogle
                })

                if (fitView) {
                    const bounds = this.getBounds(coordinatesList)

                    if (bounds) {
                        this.setViewport({ bounds })
                    } else {
                        this.locateUser()
                    }
                }

            })
            .catch(error => console.log(error))
    }

    // Новая зона — прямоугольник по центру видимой области карты, примерно 40% её размера,
    // чтобы её было видно целиком и было удобно тянуть за точки при любом масштабе.
    addNewZone() {
        const [lat, lng] = this.mapView.center
        let latHalf: number
        let lngHalf: number

        if (this.mapView.bounds) {
            const [[south, west], [north, east]] = this.mapView.bounds
            latHalf = Math.abs(north - south) / 5
            lngHalf = Math.abs(east - west) / 5
        } else {
            latHalf = lngHalf = 360 / Math.pow(2, this.mapView.zoom) / 5
        }

        const coordinates = [
            [lat + latHalf, lng - lngHalf],
            [lat + latHalf, lng + lngHalf],
            [lat - latHalf, lng + lngHalf],
            [lat - latHalf, lng - lngHalf]
        ]

        this.active.coordinates = coordinates
        this.active.coordinatesGoogle = coordinates.map(([lat, lng]) => ({ lat, lng }))
        this.active.id = 0
    }

    clearActive() {
        this.active = zonesController.defaultActive()
    }

    saveActive() {

        let facts = new FormData();
        facts.append("name", this.active.name);
        if(this.active.id_crm) facts.append("id_crm", this.active.id_crm);
        facts.append("enabled", `${+ this.active.enabled}`);
        facts.append("price", `${this.active.price}`);
        facts.append("minprice", `${this.active.minprice}`);
        facts.append("maxprice", `${this.active.maxprice}`);
        facts.append("coordinates", JSON.stringify(this.active.coordinates));
        if(this.active.waiting_time) facts.append("waiting_time", this.active.waiting_time);
        if(this.active.delivery_time) facts.append("delivery_time", `${this.active.delivery_time}`);
        if(this.active.color) facts.append("color", this.active.color);
        facts.append("price_levels", JSON.stringify(this.active.price_levels));

        // Запрос на сохранение
        let url = "/setting/delivery_zone";

        if(this.active.id > 0) {
            url = url + "/" + this.active.id;
        }

        openApi('post', url, facts)
            .then(success => {
                this.clearActive()
                this.getAllZone()

                this.modal = false;
                window.scrollTo(0, 0)
            })
            .catch(error => console.log(error));
    }

    onChange(e: any) {
        this.active.coordinates = e.get("target").geometry._coordPath._coordinates[0];
    }

    onChangeGoogle(e: number[]) {
        this.active.coordinates = e
    }

    select(id: number) {
        if(this.active.id > -1) {
            message.error(i.t('delivery:saveOrDeleteActiveZone'));
        } else {
            this.active = this.list.find(el => el.id === id);
        }
    }

    deleteByID(ID: any) {
        openApi('delete', `/setting/delivery_zone/${ID}`)
            .then(success => {
                console.log(success);
                this.getAllZone()
            })
            .catch(error => console.log(error));
    }

    edit(ID: any) {
        // Новая, ещё не сохранённая зона — в списке её нет, просто открываем её настройки.
        if (ID === 0) {
            this.modal = true
            return
        }

        const found = this.list.find(el => el.id === ID);

        this.active = {
            id: found.id,
            enabled: found.enabled,
            name: found.name,
            id_crm: found.id_crm,
            price: found.price,
            minprice: found.minprice,
            maxprice: found.maxprice,
            coordinates: found.coordinates,
            coordinatesGoogle: found.coordinatesGoogle,
            waiting_time: found.waiting_time ?? null,
            delivery_time: found.delivery_time ?? null,
            color: found.color ?? null,
            price_levels: (found.price_levels ?? []).map((level: any) => ({
                max_cart: level.max_cart,
                price: level.price
            }))
        }
        this.modal = true;
    }

    delete() {
        if(this.active.id > 0) {
            this.deleteByID(this.active.id)
            this.clearActive();
        } else {
            this.clearActive();
        }
    }

    saveDataZone(e: FormEvent) {
        e.preventDefault()
        this.closeModal()

        if(this.active.id < 0) {
            // Зона появляется в видимой области — карту не двигаем.
            this.addNewZone()
        } else if(this.active.id > 0) {
            const bounds = this.getBounds(this.active.coordinates)
            if (bounds) this.setViewport({ bounds })
        }

        window.scrollTo(0,0)
    }

    onChangeInput(name: string, value: any) {
        // @ts-ignore
        this.active[name] = value;
    }

    addPriceLevel() {
        this.active.price_levels.push({ max_cart: null, price: null })
    }

    removePriceLevel(index: number) {
        this.active.price_levels.splice(index, 1)
    }

    updatePriceLevel(index: number, field: 'max_cart' | 'price', value: number | null) {
        this.active.price_levels[index][field] = value
    }

    // Границы области, в которую попадают все точки; битые точки (null, пустые) пропускаем.
    getBounds(list: any[]): MapBounds | null {
        let minLat = Infinity
        let maxLat = -Infinity
        let minLng = Infinity
        let maxLng = -Infinity

        list.forEach((item: any) => {
            if (!item || item[0] === null || item[1] === null || item[0] === '' || item[1] === '') return

            const lat = Number(item[0])
            const lng = Number(item[1])
            if (!Number.isFinite(lat) || !Number.isFinite(lng)) return

            minLat = Math.min(minLat, lat)
            maxLat = Math.max(maxLat, lat)
            minLng = Math.min(minLng, lng)
            maxLng = Math.max(maxLng, lng)
        })

        if (minLat === Infinity) {
            return null
        }

        return [[minLat, minLng], [maxLat, maxLng]]
    }
}